import useResizeObserver from "./useResizeObserver"

export function addTabIndexIfHasScrollBar(entry) {
  const hasScroll =
    entry.target.scrollHeight > entry.target.clientHeight ||
    entry.target.scrollWidth > entry.target.clientWidth
  const tabIndex = hasScroll ? 0 : -1

  entry.target.setAttribute("tabindex", tabIndex)
}

/**
 * We need to add tabindex when we add scroll https://dequeuniversity.com/rules/axe/3.5/scrollable-region-focusable
 * @returns {object} with 2 properties: ref and setRef, a function to update element reference
 */
export default function useScrollTabIndex() {
  return useResizeObserver(addTabIndexIfHasScrollBar)
}
